export default "__VITE_ASSET__i503KOYU__"